import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fea9236"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "swapBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, [
  /*#__PURE__*/_createTextVNode(" 研究数据显示，"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "金黄色葡萄球菌对"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "莫匹罗星未出现耐药性")
], -1))
const _hoisted_5 = { class: "bakBox" }
const _hoisted_6 = { class: "reportBox" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reportText" }, " 选取2013年2月-2018 年10厦门大学附属第一医院皮肤科SSTIs患者创面分泌物或脓液942份标本，采用西门子全自动微生物分析仪及配套细菌鉴定卡进行菌种鉴定，942份标本中检出病原菌共456株，检出率为48.41%。对革兰阳性球菌耐药性分析时选用青霉素、氨苄西林、庆大霉素、米诺环素、环丙沙星、左氧氟沙星、头孢唑林、利福平、克林霉素、琥乙红霉素、莫匹罗星、利奈唑胺、万古霉素及替拉考宁14种药敏试验药物；对革兰阴性杆菌耐药性分析时选用氨苄西林、阿莫西林、庆大霉素、阿米卡星、头孢唑林、头孢哌酮、头孢哌酮舒巴 坦、头孢他啶、头孢吡肟、哌拉西林、亚胺培南、美罗培南、氨曲南及磺胺甲唑／甲氧苄啶14种药敏试验药物，采用西门子微生物鉴定药敏仪进行药敏试验，菌株的鉴定与耐药性分析采用BD Phoenix全自动微生物分析仪进行。结果判定严格参照2013年美国临床实验室标准化委员会所制定的抗微生物药敏性试验执行标准 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleBox" }, [
  /*#__PURE__*/_createTextVNode(" 耐甲氧西林金黄色葡萄球菌（MRSA）对莫匹罗星"),
  /*#__PURE__*/_createElementVNode("span", { class: "red" }, "耐药率低，敏感率高")
], -1))
const _hoisted_9 = { class: "footBox" }
const _hoisted_10 = { class: "reportBox" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footDetail" }, " 收集2007-2010年全国23家医院的金黄色葡萄球菌1007株，用琼脂二倍稀释法进行最低抑菌浓度(MIC)测定，评价莫匹罗星对临床分离金黄色葡萄球菌的体外抗菌活性 ", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1. 柯晓苹,等. 中国医院药学杂志, 2019, 39(20):4 "),
  /*#__PURE__*/_createElementVNode("span", null, " 2. 李耘,等.中国临床药理学杂志,2012,28(7)：508-512.")
], -1))
const _hoisted_13 = { class: "home" }
const _hoisted_14 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        width: "2.1333rem",
        height: ".6667rem",
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_van_image, {
            width: "7.56rem",
            height: "2.5rem",
            src: require('../assets/rep.jpg')
          }, null, 8, ["src"])
        ]),
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_van_image, {
              width: "9.4rem",
              height: "3.3rem",
              src: require('../assets/repfoot.jpg')
            }, null, 8, ["src"])
          ])
        ]),
        _hoisted_11,
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_van_image, {
            onClick: $options.nexStept,
            width: "2.5733rem",
            height: "2.5733rem",
            src: require('../assets/jixu.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
    }, {
      default: _withCtx(() => [
        ($data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 0,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true),
        (!$data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 1,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}